import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountBillingManagerPageComponent } from './account-billing-manager.page';

const routes: Routes = [
    {
        path: '',
        component: AccountBillingManagerPageComponent
    }
];
@NgModule({ imports: [RouterModule.forChild(routes)], exports: [RouterModule] })
export class AccountBillingManagerRoutingModule {}
